import { createSlice } from "@reduxjs/toolkit";
import {
  getNatCategory,
  getPatientList,
  getPersonalInfo,
  verifyPersonalInfo,
  rejectRequest,
  getCurrentAddress,
  verifyAddress,
  uploadMedia,
  getNationalId,
  verifyNationalId,
  getInsuranceId,
  verifyInsuranceId,
  verifyHnNumber,
  editPatientProfile,
  rejectEditRequest,
  getEditRequest,
  updateEditRequest,
  verifyRelativeProfileRequest,
  getVerifiedPfp,
  getSingleVPfp,
  getRegisteredPatientList,
} from "./patientProfileThunk";

const initialState = {
  idList: null,
  idListErr: null,
  patientList: null,
  patientListError: null,
  patientEditProfileList: null,
  patientEditProfileListError: null,
  personalInfo: null,
  personalInfoError: null,
  verifyPrsnlInfo: null,
  verifyPrsnlInfoError: null,
  rejectHnReq: null,
  rejectHnReqErr: null,
  verfiyAddReq: null,
  verfiyAddReqErr: null,
  getCurrentAdd: null,
  getCurrentAddErr: null,
  uploadMediaSuccess: null,
  uploadMediaErr: null,
  getNatIdSuccess: null,
  getNatIdErr: null,
  verifyNatIdsuccess: null,
  verifyNatIdErr: null,
  getInsuranceSuccess: null,
  getInsuranceErr: null,
  verifyInsuranceSuccess: null,
  verifyInsuranceErr: null,
  verifyHnNumberSuccess: null,
  verifyHnNumberErr: null,
  rejectEditReqSuccess: null,
  rejectEditReqErr: null,
  patientEditRequest: null,
  patientEditRequestError: null,
  updateEditRequestData: null,
  updateEditRequestError: null,
  verifyRelativeProfile: null,
  verifyRelativeProfileError: null,
  getVerifiedPfpSuccess: null,
  getVerifiedPfpErr: null,
  getSingleVPfpSuccess: null,
  getSingleVPfpErr: null,
  getRegisteredPatientListSuccess: null,
  getRegisteredPatientListErr: null,
};

const patientProfileListSlice = createSlice({
  name: "patientProfileList",
  initialState,
  reducers: {
    resetGetProfileList(state) {
      state.patientListError = null;
    },
    resetEditProfileRequest(state) {
      state.patientEditProfileListError = null;
    },
    resetIdList(state) {
      state.idListErr = null;
    },
    resetPersonalInfo(state) {
      state.personalInfoError = null;
      state.personalInfo = null;
    },
    resetVerifyPrsnlInfo(state) {
      state.verifyPrsnlInfo = null;
      state.verifyPrsnlInfoError = null;
    },
    resetRejectHnReq(state) {
      state.rejectHnReq = null;
      state.rejectHnReqErr = null;
    },
    resetVerifyAddReq(state) {
      state.verfiyAddReq = null;
      state.verfiyAddReqErr = null;
    },
    resetCurrentAdd(state) {
      state.getCurrentAdd = null;
      state.getCurrentAddErr = null;
    },
    resetUploadMedia(state) {
      state.uploadMediaErr = null;
      state.uploadMediaSuccess = null;
    },
    resetGetNatId(state) {
      state.getNatIdErr = null;
      state.getNatIdSuccess = null;
    },
    resetVerifyNatId(state) {
      state.verifyNatIdErr = null;
      state.verifyNatIdsuccess = null;
    },
    resetInsuranceId(state) {
      state.getInsuranceErr = null;
      state.getInsuranceSuccess = null;
    },
    resetVerifyInsuranceId(state) {
      state.verifyInsuranceErr = null;
      state.verifyInsuranceSuccess = null;
    },
    resetVerifyHnNumber(state) {
      state.verifyHnNumberSuccess = null;
      state.verifyHnNumberErr = null;
    },
    resetRejectEditReq(state) {
      state.rejectEditReqSuccess = null;
      state.rejectEditReqErr = null;
    },
    resetEditRequest(state) {
      state.patientEditRequest = null;
      state.patientEditRequestError = null;
    },
    resetUpdateRequest(state) {
      state.updateEditRequestData = null;
      state.updateEditRequestError = null;
    },
    resetVerifyProfile(state) {
      state.verifyRelativeProfile = null;
      state.verifyRelativeProfileError = null;
    },
    resetGetVerifiedPfp(state) {
      state.getVerifiedPfpSuccess = null;
      state.getCurrentAddErr = null;
    },
    resetGetSingleVPfp(state) {
      state.getSingleVPfpSuccess = null;
      state.getSingleVPfpErr = null;
    },
    resetGetRegisteredPatientList(state) {
      state.getRegisteredPatientListSuccess = null;
      state.getRegisteredPatientListErr = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET IDENTIFICATION LIST
      .addCase(getNatCategory.fulfilled, (state, action) => {
        state.idList = action.payload;
      })
      .addCase(getNatCategory.rejected, (state, action) => {
        state.idListErr = action.error.message;
      })
      // GET PATIENT LIST OF VERFICATIONS REQUESTS
      .addCase(getPatientList.fulfilled, (state, action) => {
        state.patientList = action.payload;
      })
      .addCase(getPatientList.rejected, (state, action) => {
        state.patientListError = action.error.message;
      })
      // EDIT PATIENT PROFILE
      .addCase(editPatientProfile.fulfilled, (state, action) => {
        state.patientEditProfileList = action.payload;
      })
      .addCase(editPatientProfile.rejected, (state, action) => {
        state.patientEditProfileListError = action.error.message;
      })
      // GET PERSONAL INFO WITH AND WITHOUT (HN NUMBER)
      .addCase(getPersonalInfo.fulfilled, (state, action) => {
        state.personalInfo = action.payload;
      })
      .addCase(getPersonalInfo.rejected, (state, action) => {
        state.personalInfoError = action.error.message;
      })
      // VERIFY PERSONAL INFO (STEP 1)
      .addCase(verifyPersonalInfo.fulfilled, (state, action) => {
        state.verifyPrsnlInfo = action.payload;
      })
      .addCase(verifyPersonalInfo.rejected, (state, action) => {
        state.verifyPrsnlInfoError = action.error.message;
      })
      // REJECT VERIFICATION AND EDIT REQUESTS
      .addCase(rejectRequest.fulfilled, (state, action) => {
        state.rejectHnReq = action.payload;
      })
      .addCase(rejectRequest.rejected, (state, action) => {
        state.rejectHnReqErr = action.error.message;
      })
      // GET ADDRESS REQUEST
      .addCase(getCurrentAddress.fulfilled, (state, action) => {
        state.getCurrentAdd = action.payload;
      })
      .addCase(getCurrentAddress.rejected, (state, action) => {
        state.getCurrentAddErr = action.error.message;
      })
      // VERIFY AND UPDATE ADDRESS REQUEST
      .addCase(verifyAddress.fulfilled, (state, action) => {
        state.verfiyAddReq = action.payload;
      })
      .addCase(verifyAddress.rejected, (state, action) => {
        state.verfiyAddReqErr = action.error.message;
      })
      // UPLOAD MEDIA
      .addCase(uploadMedia.fulfilled, (state, action) => {
        state.uploadMediaSuccess = action.payload;
      })
      .addCase(uploadMedia.rejected, (state, action) => {
        state.uploadMediaErr = action.error.message;
      })
      // GET NATIONAL ID
      .addCase(getNationalId.fulfilled, (state, action) => {
        state.getNatIdSuccess = action.payload;
      })
      .addCase(getNationalId.rejected, (state, action) => {
        state.getNatIdErr = action.error.message;
      })
      // VERIFY  NATIONAL ID
      .addCase(verifyNationalId.fulfilled, (state, action) => {
        state.verifyNatIdsuccess = action.payload;
      })
      .addCase(verifyNationalId.rejected, (state, action) => {
        state.verifyNatIdErr = action.error.message;
      })
      // get  INSURANCE ID
      .addCase(getInsuranceId.fulfilled, (state, action) => {
        state.getInsuranceSuccess = action.payload;
      })
      .addCase(getInsuranceId.rejected, (state, action) => {
        state.getInsuranceErr = action.error.message;
      })
      // VERIFY  INSURANCE ID
      .addCase(verifyInsuranceId.fulfilled, (state, action) => {
        state.verifyInsuranceSuccess = action.payload;
      })
      .addCase(verifyInsuranceId.rejected, (state, action) => {
        state.verifyInsuranceErr = action.error.message;
      })
      // VERIFY  hn number
      .addCase(verifyHnNumber.fulfilled, (state, action) => {
        state.verifyHnNumberSuccess = action.payload;
      })
      .addCase(verifyHnNumber.rejected, (state, action) => {
        state.verifyHnNumberErr = action.error.message;
      })
      //REJECT EDIT REQUEST
      .addCase(rejectEditRequest.fulfilled, (state, action) => {
        state.rejectEditReqSuccess = action.payload;
      })
      .addCase(rejectEditRequest.rejected, (state, action) => {
        state.rejectEditReqErr = action.error.message;
      })
      //EDIT REQUIEST STEP1
      .addCase(getEditRequest.fulfilled, (state, action) => {
        state.patientEditRequest = action.payload;
      })
      .addCase(getEditRequest.rejected, (state, action) => {
        state.patientEditRequestError = action.error.message;
      })
      // UPDATE EDIT REQUEST
      .addCase(updateEditRequest.fulfilled, (state, action) => {
        state.updateEditRequestData = action.payload;
      })
      .addCase(updateEditRequest.rejected, (state, action) => {
        state.updateEditRequestError = action.error.message;
      })
      // VERIFY RELATIVE PROFILE REQUEST
      .addCase(verifyRelativeProfileRequest.fulfilled, (state, action) => {
        state.verifyRelativeProfile = action.payload;
      })
      .addCase(verifyRelativeProfileRequest.rejected, (state, action) => {
        state.verifyRelativeProfileError = action.error.message;
      })
      // GET VERIFIED PROFILES
      .addCase(getVerifiedPfp.fulfilled, (state, action) => {
        state.getVerifiedPfpSuccess = action.payload;
      })
      .addCase(getVerifiedPfp.rejected, (state, action) => {
        state.getVerifiedPfpErr = action.error.message;
      })
      // GET getRegisteredPatientList
      .addCase(getRegisteredPatientList.fulfilled, (state, action) => {
        state.getRegisteredPatientListSuccess = action.payload;
      })
      .addCase(getRegisteredPatientList.rejected, (state, action) => {
        state.getRegisteredPatientListErr = action.error.message;
      })
      // GET SINGLE VERIFIED PROFILE
      .addCase(getSingleVPfp.fulfilled, (state, action) => {
        state.getSingleVPfpSuccess = action.payload;
      })
      .addCase(getSingleVPfp.rejected, (state, action) => {
        state.getSingleVPfpErr = action.error.message;
      });
  },
});

export const {
  resetIdList,
  resetInsuranceId,
  resetVerifyInsuranceId,
  resetGetProfileList,
  resetPersonalInfo,
  resetVerifyPrsnlInfo,
  resetRejectHnReq,
  resetCurrentAdd,
  resetVerifyAddReq,
  resetUploadMedia,
  resetGetNatId,
  resetVerifyNatId,
  resetVerifyHnNumber,
  resetEditProfileRequest,
  resetRejectEditReq,
  resetEditRequest,
  resetUpdateRequest,
  resetVerifyProfile,
  resetGetVerifiedPfp,
  resetGetSingleVPfp,
  resetGetRegisteredPatientList,
} = patientProfileListSlice.actions;
export default patientProfileListSlice.reducer;
